import { Injectable } from "@angular/core";
import { RestServiceBase } from "@definitiv-packages/angular-dba-library";
import { SafetyPointFormModel } from "../../types/SafetyPointFormModel";
 
@Injectable({
    providedIn: 'root'
})
export class SafetyPointFormModelService extends RestServiceBase<SafetyPointFormModel> {
    constructor(
    ) {
        super("SafetyPointFormModel", false);
    }

 
}